import { Dimensions, Platform } from "react-native";
import Color from "../../assets/color/Color";
import StyleSheet from "react-native-media-query";
import { theme } from "../../theme/theme";
import commonStyle from "../../assets/styles/common-style";
export const { ids, styles } = StyleSheet.create({
  containerFluid: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // minHeight: 900,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  rightPanel: {
    backgroundColor: theme.colors.white,
    height: "100%",
    zIndex: 2,
    ...Platform.select({
      ios: {
        width: "100%",
        "@media (min-width: 200px)": {
          // width: "80%",
        },
        "@media (min-width: 380px)": {
          // width: "80%",
          paddingTop: 30,
        },
        "@media (min-width: 700px)": {
          // width: "60%",
          paddingTop: 0,
        },
        height: "110%",
      },
      android: {
        width: "100%",
        "@media (min-width: 200px)": {
          width: "100%",
        },
        "@media (min-width: 380px)": {
          width: "100%",
        },
        "@media (min-width: 700px)": {
          // width: "65%",
          paddingTop: 0,
        },
        height: "100%",
      },
      web: {
        "@media (min-width: 200px)": {
          width: "100%",
        },
        "@media (min-width: 700px)": {
          width: "60%",
        },
        "@media (min-width: 1000px)": {
          width: "55%",
        },
        "@media (min-width: 1200px)": {
          width: "40%",
        },
        "@media (min-width: 1400px)": {
          width: "30%",
        },
        height: "100%",
      },
    }),
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.colors.black + 50,
  },
  notificationContainer: {
    top: theme.spacing.cs,
    ...Platform.select({
      ios: {
        display: "flex",
        flex: 1,
        "@media (min-width: 200px)": {
          // iPhone 7, 8
          top: 15,
        },
        "@media (min-width: 700px)": {
          // iPhone 7, 8
          top: 34,
        },
      },
      android: {
        display: "flex",
        flex: 1,
        "@media (min-width: 200px)": {
          // iPhone 7, 8
          top: 15,
        },
        "@media (min-width: 700px)": {
          // iPhone 7, 8
          height: Dimensions.get("window").height,
          top: 10,
        },
      },
      web: {
        overflowY: "scroll",
        position: "absolute",
        top: 75,
        bottom: 0,
        left: 0,
        right: 0,
      },
    }),
  },
  alreadyReadList: {
    backgroundColor: theme.colors.white,
  },
  alreadyRead: {
    backgroundColor: theme.colors.black + 30,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: theme.colors.black + 30,
  },
  alreadyReadText: {
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.text.secondary,
  },
  notificationList: {
    padding: 16,
    backgroundColor: theme.colors.primary + 20,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.black + 10,
    ...Platform.select({
      web: {
        cursor: "pointer",
      },
    }),
  },

  notificationText: {
    fontSize: 16,
    fontWeight: "500",
    fontStyle: "normal",
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.text.secondary,
  },
  heading: {
    fontSize: 20,
    fontWeight: "500",
    fontStyle: "normal",
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.text.secondary,
    fontFamily: theme.fontFamily.robotoSlabBold,
    display: "flex",
    flex: 1,
    paddingLeft: 16,
  },

  closePanel: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop:theme.spacing.cs,
    paddingBottom: theme.margin.reg,
    paddingRight: theme.spacing.md,
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.black + 50,
    ...Platform.select({
      ios: {
        "@media (min-width: 100px)": {
          // iPad Pro 9.7
          paddingTop: theme.spacing.md,
          top: theme.spacing.cs,
        },
        "@media (min-width: 380px)": {
          // iPad Pro 9.7
          top: theme.spacing.cs,
          paddingTop: 0,
          // bottom: 'calc(0 - 30)'
        },
        "@media (min-width: 700px)": {
          // iPad Pro 9.7
          top: 34,
        },
      },
      android: {
        "@media (min-width: 700px)": {
          // iPad Pro 9.7
          top: 10,
        },
      },
      web: {},
    }),
  },
  profileSection: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
  },
  Logo: {
    width: 110,
    height: 30,
    "@media (min-width: 700px)": {
      // iPad Pro 9.7
      width: 150,
      height: 40,
    },
    "@media (min-width: 1000px)": {
      //iPad Pro 12.9
      width: 180,
      height: 48,
    },
  },
  signOut: {
    width: 20,
    height: 20,
    marginRight: 12,
    position: "relative",
    top: 1,
  },
  crossIcon: {
    width: 20,
    height: 20,
    "@media (min-width: 700px)": {
      width: 18,
      height: 18,
    },
  },
  crossIconTouch: {
    width: 44,
    height: 44,
    alignItems: "center",
    justifyContent: "center",
  },
  logoutItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    marginTop: 44,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  listLogoItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 160,
  },
  justifyContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  userNameText: {
    color: "#000",
    fontSize: 16,
    fontWeight: "600",
    marginLeft: 12,
    ...Platform.select({
      ios: {
        width: "70%",
      },
      android: {
        width: "65%",
      },
      web: {
        width: "90%",
      },
    }),
  },
  Profile: {
    width: 26,
    height: 26,
    ...Platform.select({
      ios: {
        "@media (min-width: 700px)": {
          width: 30,
          height: 30,
        },
        "@media (min-width: 1000px)": {
          width: 35,
          height: 35,
        },
      },
      android: {
        "@media (min-width: 485px)": {
          // Android small tablet
          width: 30,
          height: 30,
        },
        "@media (min-width: 700px)": {
          // Android medium (Galaxy S4) tablet
          width: 30,
          height: 30,
        },
        "@media (min-width: 900px)": {
          // Android large tablet
          width: 35,
          height: 35,
        },
      },
      web: {},
    }),
  },
});
